import { executeOnDocumentReady } from '../../../utils';

export default function () {
	executeOnDocumentReady(function () {
		const showMapIframes = document.querySelectorAll('.show-map-iframe');

		if (showMapIframes.length === 0) {
			return false;
		}

		for (const showMapIframe of showMapIframes) {
			showMapIframe.addEventListener('click', function (e) {
				e.preventDefault();
				const iframeId = showMapIframe.getAttribute('href');
				const container = document.querySelector(iframeId);
				const iframe = document.querySelector(iframeId + ' > iframe');
				const parent = container.parentNode;

				container.classList.toggle('iframe-visible');
				parent.classList.toggle("hidden");

				if (container.classList.contains('iframe-visible')) {
					showMapIframe.textContent = 'Skrýt mapu';
				} else {
					showMapIframe.textContent = 'Zobrazit na mapě';
				}

				if (!iframe) {
					setTimeout(() => {
						const iframe = document.createElement('iframe');
						iframe.className = 'offer-iframe-map';
						iframe.src = container.getAttribute('data-src');
						iframe.loading = 'lazy';
						container.appendChild(iframe);
					}, 200);
				}
			});
		}
	})
}
